import { createContext } from "react";

import type { Api } from "../openapi";

export interface ApiContextState {
  api: Api<void>;
}

const ApiContext = createContext<ApiContextState>({
  api: null!,
});

export default ApiContext;
